/* eslint-disable no-console */

import environment from '@/environment';

function shouldLog(): boolean {
  return !!environment.DEBUG;
}

export const logger = {
  log(...args: unknown[]) {
    if (!shouldLog()) return;
    console.log(...args);
  },

  info(...args: unknown[]) {
    if (!shouldLog()) return;
    console.info(...args);
  },

  warn(...args: unknown[]) {
    if (!shouldLog()) return;
    console.warn(...args);
  },

  error(...args: unknown[]) {
    if (!shouldLog()) return;
    console.error(...args);
  },

  debug(...args: unknown[]) {
    if (!shouldLog()) return;
    console.debug(...args);
  },
};
